import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=4b3c6212&scoped=true&"
import script from "./GenericCard.vue?vue&type=script&lang=js&"
export * from "./GenericCard.vue?vue&type=script&lang=js&"
import style0 from "./GenericCard.vue?vue&type=style&index=0&id=4b3c6212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c6212",
  null
  
)

export default component.exports